import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import {
  ONBOARDING_TEMPLATES_RESOURCE,
  CREATE_ONBOARDING_TEMPLATE_RESOURCE,
} from '../../constants';

const CreateOnboardingTemplateService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_ONBOARDING_TEMPLATE_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.onboardingTemplates(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: ONBOARDING_TEMPLATES_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createOnboardingTemplateFailed'),
            onSuccessMessage: t('createOnboardingTemplateSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateOnboardingTemplateService;
